/**
 * Verifies if a string is a valid URL (http/https only).
 */
export default function isValidUrl(url) {
  let urlInstance;
  try {
    urlInstance = new URL(url);
  } catch (_) {
    return false;
  }
  return ['http:', 'https:'].includes(urlInstance.protocol);
}
flarum.reg.add('fof-socialprofile', 'forum/helpers/isValidUrl', isValidUrl);